module.exports = __webpack_public_path__ + "static/media/ket.d8fc7370.png";